
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-cyber-black/90 backdrop-blur-sm' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <div className="glitch-effect text-3xl font-pixel text-shadow-glow" data-text="SpecialAgentK.eth.limo">
            SpecialAgentK.eth.limo
          </div>
        </div>
        <nav>
          <ul className="flex space-x-6">
            <li>
              <Link to="/" className="relative font-cyber text-lg hover:text-shadow-glow transition-all duration-300 before:content-['<'] before:opacity-0 before:absolute before:-left-4 hover:before:opacity-100 before:transition-opacity after:content-['>'] after:opacity-0 after:absolute after:-right-4 hover:after:opacity-100 after:transition-opacity">
                HOME
              </Link>
            </li>
            <li>
              <Link to="/about" className="relative font-cyber text-lg hover:text-shadow-glow transition-all duration-300 before:content-['<'] before:opacity-0 before:absolute before:-left-4 hover:before:opacity-100 before:transition-opacity after:content-['>'] after:opacity-0 after:absolute after:-right-4 hover:after:opacity-100 after:transition-opacity">
                ABOUT
              </Link>
            </li>
            <li>
              <Link to="/work" className="relative font-cyber text-lg hover:text-shadow-glow transition-all duration-300 before:content-['<'] before:opacity-0 before:absolute before:-left-4 hover:before:opacity-100 before:transition-opacity after:content-['>'] after:opacity-0 after:absolute after:-right-4 hover:after:opacity-100 after:transition-opacity">
                THINGS
              </Link>
            </li>
            <li>
              <Link to="/contact" className="relative font-cyber text-lg hover:text-shadow-glow transition-all duration-300 before:content-['<'] before:opacity-0 before:absolute before:-left-4 hover:before:opacity-100 before:transition-opacity after:content-['>'] after:opacity-0 after:absolute after:-right-4 hover:after:opacity-100 after:transition-opacity">
                CONTACT
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
